export default __webpack_public_path__ + "static/media/Slider-2_compressed.94353e21.jpg";